import React, { useState, useEffect } from 'react';
import styles from './ReferralBanner.module.css'; // Reusing the same styles
import { IoShareOutline } from "react-icons/io5";
import ShareBottomSheet from "../ShareBottomSheet/ShareBottomSheet";

const ReferralBanner = ({
                            title = 'Refer your friends to earn $100',
                            description = 'Share this app with your friends and earn $100 when they sign up!',
                            buttonText = 'Share Now',
                            delay = 1000,
                            dismissalTime = 7 * 24 * 60 * 60 * 1000,
                            product = null // Default to null if no product is provided
                        }) => {
    const [active, setActive] = useState(false);
    const [showBanner, setShowBanner] = useState(false);
    const [userDismissed, setUserDismissed] = useState(false);
    const [shareSheetOpen, setShareSheetOpen] = useState(false);

    // Check for stored dismissal time in localStorage when component mounts
    useEffect(() => {
        const dismissedUntil = localStorage.getItem('referral-banner-dismissed-until');
        if (dismissedUntil && Number(dismissedUntil) > Date.now()) {
            setUserDismissed(true);
        }
    }, []);

    // Show banner after delay
    useEffect(() => {
        if (userDismissed) {
            return;
        }

        // Simple delay timer
        const timer = setTimeout(() => {
            setShowBanner(true);
            setTimeout(() => {
                setActive(true);
            }, 1000);
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [delay, userDismissed]);

    // Create a default product object if none is provided
    const shareProduct = product || {
        id: null,
        name: "pluug",
        brand_name: "",
        dispensary: { name: "" },
        pricing: [{ price: 0, discount_price: 0, unit: "" }]
    };

    const handleShare = () => {
        setShareSheetOpen(true);
    };

    const handleDismiss = () => {
        // Set state to hide the banner
        setActive(false);
        setTimeout(function () {
            setShowBanner(false);
        }, 1000);

        setUserDismissed(true);

        // Store dismissal time in localStorage
        const dismissalExpiry = Date.now() + dismissalTime;
        localStorage.setItem('referral-banner-dismissed-until', dismissalExpiry.toString());
    };

    if (!showBanner) {
        return null;
    }

    return (
        <>
            <div
                className={`${styles.referralBanner} ${active ? styles.active : ''} referral-banner w-[100%] h-[132px] bg-dark-bg fixed top-0 left-0 z-[9999999999999]`}
                style={{ borderBottomRightRadius: '9px', borderBottomLeftRadius: '9px' }}
            >
                <div className="referral-banner-content px-3">
                    <h3 className="mb-1 mt-3">{title}</h3>
                    <p className="mt-0">{description}</p>
                    <div className="referral-banner-buttons flex gap-1 justify-between">
                        <button
                            className="share-button rounded-xxs border-0 bg-brand-green p-2 inline-flex items-center gap-1 text-black"
                            onClick={handleShare}
                        >
                            <IoShareOutline size={18} />
                            {buttonText}
                        </button>
                        <button
                            className="dismiss-button rounded-xxs border-0 bg-dark-bg text-white p-2"
                            onClick={handleDismiss}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>

            {/* Render ShareBottomSheet only when open */}
            {shareSheetOpen && (
                <ShareBottomSheet
                    product={shareProduct}
                    open={shareSheetOpen}
                    onOpenChange={setShareSheetOpen}
                />
            )}
        </>
    );
};

export default ReferralBanner;
